import { css } from 'styled-components';

const baseGlobalStyles = css`
  /* TODO: Add global style reset file? */

  html {
    box-sizing: border-box;
    font: 100%/1.5 ${Styles.fontFamily.body};
    color: ${Styles.color.black};
    -webkit-font-smoothing: antialiased;
  }

  /* hide google stuff - might be a better way to hide copyright, terms of use, and report map errors buttons */
  .gm-style-cc {
    display: none;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  .no-scroll {
    overflow: hidden;
  }

  html,
  body,
  #root {
    margin: 0;
    padding: 0;
  }

  :focus {
    outline: -webkit-focus-ring-color auto 5px;
    outline-color: -webkit-focus-ring-color;
    outline-style: auto;
    outline-width: 5px;
  }

  /* work around for Edge not supporting outline-style: auto */
  @supports (-ms-ime-align: auto) {
    :focus {
      outline-color: invert;
      outline-width: 3px;
      outline-style: dotted;
    }
  }

  a {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-touch-callout: none;
  }

  // Resets default browser styles
  p {
    font-weight: normal;
  }

  [role='main' id='main'] {
    ${Styles.mobileFullscreen`
      padding-top: env(safe-area-inset-top, 0rem);
      padding-bottom: env(safe-area-inset-bottom, 0rem);
    `}
  }

  body.hide-root #root {
    opacity: 0;
  }
`;

export default baseGlobalStyles;
